// extracted by mini-css-extract-plugin
export default {"box":"CenteredModal_box__8v0qQ","footer":"CenteredModal_footer__-hIfT"};